import { FileIngestionResults } from '@ouster/webviz-react-components';

import { createDrive, getFilesByUploadId } from './createDrives';
import { fetchWithAuth } from './requests';
import { DataCategory, User, Tag } from '../types';
// import { BASE_ORG_API } from './constants';

/**
 * onSubmit for upload creation
 * @param selectedTags list of tags for upload
 * @param uploaderEndpoint uploader endpoint string
 * @param orgId organization ID
 * @param isOsf boolean indicating if the upload is for OSF data
 * @param uploadSessionID upload session
 * @param dataCategory user selected data category
 * @param configInfo uploaded file info and ingestion results
 * @param user user submitting the upload
 */
export async function onSubmit(
  selectedTags: Tag[],
  uploaderEndpoint: string,
  orgId: number,
  isOsf: boolean,
  uploadSessionID?: string,
  dataCategory?: DataCategory,
  configInfo?: Array<FileIngestionResults>,
  user?: User
  // configUploadId?: string[]
) {
  /* 
    Make sure the sensor will be created in order of their product serial number
  */
  if (configInfo) {
    configInfo.sort((a, b) => {
      const snA = a.prod_sn?.toString() || '';
      const snB = b.prod_sn?.toString() || '';

      if (snA === snB) {
        return 0;
      }
      if (!snA) {
        return 1; // If snA is undefined, place it after snB
      }
      if (!snB) {
        return -1; // If snB is undefined, place it after snA
      }
      return snA.localeCompare(snB);
    });
  }

  if (!uploadSessionID) return;

  let files;
  if (isOsf) {
    files = await getFilesByUploadId(uploadSessionID, orgId);
  } else {
    files = configInfo || [];
  }

  const resp = await createDrive(
    selectedTags,
    orgId,
    uploadSessionID,
    dataCategory,
    files
  );

  if (!resp) {
    throw Error(`Failed to create drive for session ${uploadSessionID}`);
  }

  const data = (await resp.json()) as { drive_id: string };
  if (data.drive_id) {
    localStorage.setItem('drive_id', data.drive_id.toString());
  }

  // const configDeleteURL = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}/files/${configUploadId?.toString()}`;
  // await fetchWithAuth(configDeleteURL, {
  //   method: 'DELETE',
  // });

  if (uploadSessionID && dataCategory) {
    const closeSessionUrl = `${uploaderEndpoint}/${uploadSessionID}`;
    const refreshToken = localStorage.getItem('kcRefreshToken');
    const response = await fetchWithAuth(closeSessionUrl, {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        state: 'closed',
        refresh_token: refreshToken,
        attributes: {
          tags: selectedTags.map((tag) => tag.id),
          data_category: dataCategory.id,
          user: (user && user.name) || 'John Doe',
        },
      }),
    });
    if (!response.ok) {
      throw Error(`Failed to close upload session ${uploadSessionID}`);
    }
  } else {
    console.warn('No data category or upload session');
    throw Error('No data category or upload session');
  }
}
